import { showConfirmModal } from '@clickbar/tailwindui-vue'

import { trans } from '@/plugins/i18n'

export function useCatchUnknownErrors() {
  router.on('invalid', (event) => {
    if (
      event.detail.response.status >= 500 &&
      event.detail.response.headers['content-type'] === 'application/json'
    ) {
      event.preventDefault()
      void showConfirmModal(
        trans('unknown_error_occurred'),
        trans('unknown_error_occurred_try_again_or_contact_support'),
        {
          type: 'error',
          positiveText: trans('close'),
          negativeText: trans('to_contact_form'),
          center: true,
        },
        function handle(result) {
          if (result) {
            router.visit(route('tenant.contact.index'))
          }
        },
      )
    }
  })
}
